module.exports = __webpack_public_path__ + "img/event_carpet_expoluxe_9551_apple.173fe0cf.jpg";